// Authenticated shell layout: redirects to sign-in when signed out (with a redirect back to this page unless the user signed out), preloads /me and /jurisdictions, then renders the app shell.
import { createFileRoute, redirect } from "@tanstack/react-router";

import { metaListJurisdictionsOptions } from "@/api/__generated__/@tanstack/react-query.gen";
import { meQueryOptions } from "@/app/session";
import { AppShell } from "@/app/shell/AppShell";
import { ShellError, ShellPending } from "@/app/shell/RouteStates";

export const Route = createFileRoute("/_app")({
  beforeLoad: ({ context, location }) => {
    if (context.auth.status !== "authenticated") {
      throw redirect({ to: "/signin", search: context.auth.signedOut ? {} : { redirect: location.href } });
    }
  },
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.query({ ...meQueryOptions(), staleTime: "static" }),
      context.queryClient.query({ ...metaListJurisdictionsOptions(), staleTime: "static" }),
    ]);
  },
  component: AppShell,
  pendingComponent: ShellPending,
  errorComponent: ShellError,
});
